export const SEARCH = 'SEARCH';
export const SWITCH_TAB = 'SWITCH_TAB';
export const SET_MUTED = 'SET_MUTED';
export const SET_DATA = 'SET_DATA';